import { useEffect, useState } from 'react'
import _isEmpty from 'lodash/isEmpty';
import { showLoader } from 'store/actions/commons';
import { useStore } from 'store';
import { BASE_PATH_API } from 'constants/env';
import useUpdateGifts from './useUpdateGifts'

const useGiftsData = () => {
    
    const Domain = BASE_PATH_API
    const [storeGiftTable, dispatch] = useStore((state) => state.giftTable.giftTable)

    const {
        STORAGE_GIFT_TABLE,
        setResponseEvents
    } = useUpdateGifts()


    const [resultsEvent, setResultEvent] = useState(null)
    const getTableEvent = async ({eventID}) => {
        dispatch(showLoader());
        const idEvent = storeGiftTable?.id || eventID
        try{
            const response = await fetch( `${Domain}/gift-table/v1/gift-table/${idEvent}`)
            const data = await response.json();
            setResultEvent(data?.data)
        } catch (error) {
            console.error('Error fetching event data:', error);
        }
    }


    useEffect(()=>{
        if(!_isEmpty(STORAGE_GIFT_TABLE)){
            if(!STORAGE_GIFT_TABLE?.gifts){
                getTableEvent({eventID: storeGiftTable?.id})
            }
        }
    },[storeGiftTable])

    useEffect(()=>{
        if(!_isEmpty(resultsEvent)){
            setResponseEvents(resultsEvent)
        }
    },[ resultsEvent ])
    

    return {
        giftTable: storeGiftTable,
        dispatch
    }
}

export default useGiftsData